<script lang="ts">
  import { onMount } from "svelte";
  import { Capacitor } from "@capacitor/core";
  import WorkoutExpansionPanel from "../../components/UI/WorkoutExpansionPanel.svelte";
  import TopMenu from "../../components/TopMenu.svelte";
  import Spinner from "../../components/UI/Spinner.svelte";
  import { getWithJwt } from "../../lib/requests";
  import { dialogTypes, serverlessRoutes } from "../../lib/constants";
  import { user } from "../../stores/userStore";
  import { clientWorkouts } from "../../stores/clientStores";
  import { translate } from "lib";
  import { dialogData, loadedWorkouts } from "stores";
  import { ButtonComponent } from "ui";

  let isLoading = false;
  let programs = [];

  const fetchData = async () => {
    if (!isLoading) {
      isLoading = true;
      const url = `${serverlessRoutes.PROGRAM}/v2?clientId=${$user.id}`;
      try {
        const data = await getWithJwt(url);
        programs = data.data;
        $clientWorkouts = [];
        data.data.forEach((p) => {
          $clientWorkouts = [...p.workouts, ...$clientWorkouts];
          p.workouts.forEach((workout) => {
            $loadedWorkouts[workout.id] = { ...workout };
          });
        });

        isLoading = false;
      } catch (err) {}
    }
  };

  const onExportToPDF = async (): Promise<void> => {
    const programId = $clientWorkouts[0].programId;

    $dialogData.data = {
      url: `${serverlessRoutes.PROGRAM}/pdf`,
      entityId: programId,
      fileName: "program.pdf",
    };

    $dialogData.type = dialogTypes.PDF_DIALOG;
  };

  onMount(() => {
    fetchData();
  });
</script>

<TopMenu entity="TRAINING" />
<div class="p-4 flex flex-col gap-4 bg-white dark:bg-zinc-800">
  {#if isLoading}
    <Spinner />
  {:else if $user.expireAt && new Date($user.expireAt) < new Date()}
    <div class="text-center mt-8">
      {translate("ACCOUNT_EXPIRED_CONTACT_TRAINER")}
    </div>
  {:else}
    {#if $clientWorkouts && $clientWorkouts.length > 0}
      <div class="flex justify-center">
        <ButtonComponent on:click={onExportToPDF}>
          {translate("EXPORT_TO_PDF")}
        </ButtonComponent>
      </div>
    {/if}
    <!-- <div style="margin-bottom: -8px;" /> -->
    <div class="flex flex-col gap-4">
      {#if programs.length > 0}
        {#each $clientWorkouts as workout, i}
          {#if !programs.find((p) => p.id === workout.programId)?.workoutDisplayOptions || i < programs.find((p) => p.id === workout.programId)?.visibleWorkouts}
            <WorkoutExpansionPanel showComments={true} {workout} isExpanded={false} />
          {/if}
        {/each}
      {/if}
    </div>
  {/if}
  {#if Capacitor.isNativePlatform()}
    <div class="mb-12" />
  {/if}
</div>
